var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHomeNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25065 24.5V10.5L2.33398 12.8333L14.0007 3.5L25.6673 12.8333L22.7507 10.5V24.5H5.25065Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.084 16.9167V24.5H16.9173V16.9167H11.084Z",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 24.5H22.75",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_1076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHomeNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/homeNav.4a3ba460.svg";
export { ForwardRef as ReactComponent };